import { RegistrationCommonInputProps } from 'features/registration/interface/registration';
import { FC, useState } from 'react';
import FormRow from 'shared/components/form/formRow';
import InputText from 'shared/components/form/inputText';
import useInputFocus from 'shared/hooks/useInputFocus';

type PasswordInputType = 'password' | 'text';

const RegistrationStep4: FC<RegistrationCommonInputProps> = ({ isFieldValueValid, errors, touched, setFieldValue, values, handleBlur, t }) => {
	const inputRef = useInputFocus();
	const [passwordInputType, setPasswordInputType] = useState<PasswordInputType>('password');

	return (
		<FormRow flex={false}>
			<InputText
				autoFocus
				inputRef={inputRef}
				label={t('password')}
				type={passwordInputType}
				name="password"
				isFieldValueValid={isFieldValueValid}
				errors={errors}
				touched={touched}
				onBlur={handleBlur}
				setFieldValue={setFieldValue}
				values={values}
				onChange={(e) => setFieldValue('password', e.target.value)}
				description={t('passwordConstraintText')}
				isPasswordInput={true}
				setPasswordInputType={setPasswordInputType}
				passwordInputType={passwordInputType}
				cyTestRef="reg-password"
				cyDescriptionTestRef="reg-password-desc"
				cyErrorRef="reg-validation-error"
			/>
		</FormRow>
	);
};

export default RegistrationStep4;
